module.exports = __webpack_public_path__ + "static/media/defaultOperator.b836cd39.png";